<template>
  <li class="menu-entry" :class="{ 'is-group': isGroup, 'is-open': open && !collapsed, 'is-child': depth > 0 }">
    <button v-if="isGroup" type="button" class="menu-link group-toggle" :class="{ 'is-current': active }" :title="menu.verbose_name" :aria-expanded="open && !collapsed" :aria-controls="submenuId" @click="toggle">
      <NavigationIcon :source="iconSource" :route="menu.frontend_route_url" :name="menu.verbose_name" group inverse />
      <span v-if="!collapsed" class="menu-label">{{ menu.verbose_name }}</span>
      <svg v-if="!collapsed" class="chevron" :class="{ rotated: open }" viewBox="0 0 20 20" aria-hidden="true"><path d="m6 8 4 4 4-4" /></svg>
    </button>
    <router-link v-else :to="destination" class="menu-link" :class="{ 'is-current': active }" :title="menu.verbose_name" :aria-label="menu.verbose_name">
      <NavigationIcon :source="iconSource" :route="menu.frontend_route_url" :name="menu.verbose_name" :leaf="depth > 0" inverse />
      <span v-if="!collapsed" class="menu-label">{{ menu.verbose_name }}</span>
      <span v-if="active && !collapsed" class="current-marker" aria-hidden="true"></span>
    </router-link>
    <transition name="submenu">
      <ul v-if="isGroup && open && !collapsed" :id="submenuId" class="submenu-list">
        <MenuItem v-for="child in menu.children" :key="child.id" :menu="child" :depth="depth + 1" @expand="$emit('expand')" />
        <li v-if="!menu.children.length" class="empty-group">زیرمنویی برای این گروه تعریف نشده است.</li>
      </ul>
    </transition>
  </li>
</template>
<script>
import NavigationIcon from '../../components/NavigationIcon/index.vue';
import { isTabGroup, menuContainsRoute, menuDestination, menuIconSource } from '../../utils/adminNavigation';
export default {
  name: 'MenuItem',
  components: { NavigationIcon },
  // Only one top-level group is open at a time: the sidebar owns that state (`openId`).
  props: { menu: { type: Object, required: true }, collapsed: Boolean, depth: { type: Number, default: 0 }, openId: { type: [String, Number], default: null } },
  computed: {
    open() { return this.openId !== null && String(this.openId) === String(this.menu.id); },
    // Tab groups are one link; their children appear as tabs above the page.
    isGroup() { return !isTabGroup(this.menu) && (this.menu.has_submenu || this.menu.children.length > 0); },
    active() { return menuContainsRoute(this.menu, this.$route.path); },
    destination() { return menuDestination(this.menu); },
    iconSource() { return menuIconSource(this.menu, this.active); },
    submenuId() { return 'navigation-group-' + this._uid; },
  },
  methods: {
    toggle() {
      if (this.collapsed) { this.$emit('expand'); this.$emit('open', this.menu.id); }
      else this.$emit('open', this.open ? null : this.menu.id);
    },
  },
};
</script>
<style scoped>
.menu-entry { margin: 3px 0; list-style: none; }
.menu-link { position: relative; display: flex; align-items: center; gap: 12px; width: 100%; min-height: 46px; padding: 10px 13px; border: 0; border-radius: var(--r-sm); background: transparent; color: var(--shell-text-2); font-size: 13px; font-weight: 500; line-height: 1.7; text-align: right; transition: background-color .18s, color .18s; }
.menu-link:hover { color: #fff; background: var(--shell-bg-2); }
/* the active page carries the brand's slanted bar on its leading edge */
.menu-link.is-current { color: #fff; background: var(--shell-raised); font-weight: 700; }
.menu-link.is-current::before { content: ''; position: absolute; inset-inline-start: -2px; top: 10px; bottom: 10px; width: 5px; background: var(--pink-500); transform: skewY(var(--slant)); }
.group-toggle.is-current { background: transparent; color: #fff; }
.group-toggle.is-current::before { background: var(--teal-500); }
.menu-link:focus-visible { outline: 2px solid var(--amber-500) !important; outline-offset: 1px; }
.menu-label { flex: 1; min-width: 0; }
.menu-link .navigation-icon { width: 21px; height: 21px; flex-basis: 21px; }
.menu-link.is-current .navigation-icon { color: var(--teal-300); }
.chevron { width: 18px; height: 18px; flex-shrink: 0; fill: none; stroke: currentColor; stroke-width: 1.75; transition: transform .2s; }
.chevron.rotated { transform: rotate(180deg); }
.submenu-list { padding: 0 12px 0 0; margin: 4px 22px 10px 0; border-right: 1px solid var(--shell-line); }
.is-child .menu-link { font-size: 12.5px; min-height: 42px; gap: 10px; padding: 8px 10px; }
.is-child .navigation-icon { width: 18px; height: 18px; flex-basis: 18px; }
.current-marker { width: 7px; height: 7px; background: var(--amber-500); transform: skewX(var(--slant)); flex-shrink: 0; }
.empty-group { color: var(--shell-text-3); padding: 12px; font-size: 11px; }
.submenu-enter-active, .submenu-leave-active { transition: opacity .18s, transform .18s; }
.submenu-enter, .submenu-leave-to { opacity: 0; transform: translateY(-5px); }
</style>
